import { render, staticRenderFns } from "./TakePicture.vue?vue&type=template&id=1d0fa0a0&scoped=true&"
import script from "./TakePicture.vue?vue&type=script&lang=js&"
export * from "./TakePicture.vue?vue&type=script&lang=js&"
import style0 from "./TakePicture.vue?vue&type=style&index=0&id=1d0fa0a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d0fa0a0",
  null
  
)

export default component.exports